const ContactPositions = Object.freeze({
  OWNER: 1,
  CO_OWNER: 2,
  DIRECTOR: 3,
  MANAGER: 4,
});

export default ContactPositions;
